import React from "react"
import { AlgoliaSearchState } from "./types"

export const AlgoliaSearchStateContext = React.createContext<AlgoliaSearchState>(
  {
    initialized: false,
    searchParams: {},
    orderByOptions: [],
    updateSearchParams: () => {},
    updateSearchPage: () => {},
    clearFilters: () => {},
  }
)

export const useAlgoliaSearchState = () =>
  React.useContext(AlgoliaSearchStateContext)
